// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import echarts from 'echarts'

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
/* eslint-disable */
// var setPro = 1;
Vue.prototype.$notice = [];
let onResize;
(function (doc, win, Vue) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      Vue.prototype.$setPro = clientWidth / 3840;
      docEl.style.fontSize = 100 * (clientWidth / 3840) + 'px';
      for (let i = 0;i < Vue.prototype.$notice.length; i ++) {
        Vue.prototype.$notice[i].token()
      }
    };
  recalc();
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, function(){
    if(onResize){
      clearTimeout(onResize)
      onResize = setTimeout(()=>{
        recalc()
      },50)
    }else{
      onResize = setTimeout(()=>{
        recalc()
      },50)
    }
  }, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window, Vue)

// Vue.prototype.$setPro = setPro
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js